import { render, staticRenderFns } from "./MerchantDashboard.vue?vue&type=template&id=f66a73b2&"
import script from "./MerchantDashboard.vue?vue&type=script&lang=js&"
export * from "./MerchantDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f66a73b2')) {
      api.createRecord('f66a73b2', component.options)
    } else {
      api.reload('f66a73b2', component.options)
    }
    module.hot.accept("./MerchantDashboard.vue?vue&type=template&id=f66a73b2&", function () {
      api.rerender('f66a73b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/MerchantDashboard.vue"
export default component.exports